import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import * as serviceWorker from "./serviceWorker";
import { Provider } from "react-redux";
import store from "./store";
import "font-awesome/css/font-awesome.min.css";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { createBrowserHistory  } from "history";

const history = createBrowserHistory ();

ReactDOM.render(
  <Provider store={store}>
    <React.Suspense fallback={<span></span>}>
      <BrowserRouter history={history}>
        <App />
      </BrowserRouter>
    </React.Suspense>
    <ToastContainer />
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
